import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable camelcase */
import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { getToken, renewToken, loginService, verify2faService, getMyUser, softLogout, getAllOffices, getAllEmployees, getTenantConfig, getCurrencyConfig } from 'services';
import { ROLES } from 'enums';
import { getCacheVal, setCacheVal, showApiError, setCurrencyConfig } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";
var admin = ROLES.admin,
    tenant_manager = ROLES.tenant_manager,
    franchisee_owner = ROLES.franchisee_owner,
    office_manager = ROLES.office_manager,
    employee = ROLES.employee,
    partner = ROLES.partner,
    partner_manager = ROLES.partner_manager;
var currentOffice = 'currentOffice';
var UserContext = /*#__PURE__*/React.createContext({});
export var useUser = function useUser() {
  return useContext(UserContext);
};
var initialState = {
  isAuthenticated: !!getToken(),
  userInfo: null,
  euroRate: 1.95583,
  tenant: null,
  error: null,
  loaded: false
};
export var tenantHeader = function tenantHeader() {
  return getToken() ? "Bearer ".concat(getToken().access_token) : '';
};
export var UserProvider = function UserProvider(props) {
  var children = props.children;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    init();
  }, []);
  useEffect(function () {
    if (state !== null && state !== void 0 && state.loaded) document.getElementById('splash-screen').style.display = 'none';
  }, [state === null || state === void 0 ? void 0 : state.loaded]);

  var init = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var host, rawSubdomain, subdomain, calls, _yield$Promise$all, _yield$Promise$all2, _yield$Promise$all2$, res, err, _yield$Promise$all2$2, currencyConfig, error;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              host = window.location.host || '';
              rawSubdomain = host.split('.')[0]; // On Vercel or localhost, fall back to default tenant

              subdomain = host.includes('vercel.app') || host.includes('localhost') ? 'demo' : rawSubdomain;
              axios.defaults.headers.common.Tenant = subdomain; // Fire tenant, currency (and token renewal if authenticated) in parallel

              calls = [getTenantConfig(subdomain), getCurrencyConfig()];
              if (state.isAuthenticated) calls.push(renewToken());
              _context.next = 8;
              return Promise.all(calls);

            case 8:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              _yield$Promise$all2$ = _slicedToArray(_yield$Promise$all2[0], 2);
              res = _yield$Promise$all2$[0];
              err = _yield$Promise$all2$[1];
              _yield$Promise$all2$2 = _slicedToArray(_yield$Promise$all2[1], 2);
              currencyConfig = _yield$Promise$all2$2[0];
              error = _yield$Promise$all2$2[1];

              if (!err) {
                _context.next = 18;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 18:
              if (!error) {
                _context.next = 20;
                break;
              }

              return _context.abrupt("return", showApiError(error));

            case 20:
              // Set currency config in global store
              setCurrencyConfig(currencyConfig);
              state.isAuthenticated ? fetchUserData(res, currencyConfig) : setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  tenant: res,
                  loaded: true
                });
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function init() {
      return _ref.apply(this, arguments);
    };
  }();

  var fetchUserData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tenantConfig) {
      var _yield$getMyUser, _yield$getMyUser2, res, err, roleAdditionalData;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getMyUser();

            case 2:
              _yield$getMyUser = _context2.sent;
              _yield$getMyUser2 = _slicedToArray(_yield$getMyUser, 2);
              res = _yield$getMyUser2[0];
              err = _yield$getMyUser2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              _context2.next = 10;
              return getRoleAdditionalData(res);

            case 10:
              roleAdditionalData = _context2.sent;
              setState(function (prev) {
                return _objectSpread(_objectSpread(_objectSpread({}, prev), roleAdditionalData && {
                  roleAdditionalData: roleAdditionalData
                }), {}, {
                  userInfo: _objectSpread(_objectSpread({}, res), {}, {
                    currentOffice: checkCurrentOffice(res === null || res === void 0 ? void 0 : res.offices)
                  }),
                  tenant: tenantConfig,
                  isAuthenticated: true,
                  loaded: true
                });
              });

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchUserData(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var checkCurrentOffice = function checkCurrentOffice(offices) {
    var savedOffice = getCacheVal(currentOffice);
    if (savedOffice) return savedOffice;
    return offices.at(0);
  };

  var changeCurrentOffice = function changeCurrentOffice(office) {
    setCacheVal(currentOffice, office);
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        userInfo: _objectSpread(_objectSpread({}, prev === null || prev === void 0 ? void 0 : prev.userInfo), {}, {
          currentOffice: office
        })
      });
    });
  };

  var getRoleAdditionalData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
      var user_role, data, canViewEmployees, canViewOffices, _yield$Promise$all3, _yield$Promise$all4, _yield$Promise$all4$, employees, employeesErr, _yield$Promise$all4$2, offices, officesErr;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              user_role = _ref3.user_role;

              if (user_role) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", null);

            case 3:
              data = {
                canViewEmployees: false,
                canViewOffices: false,
                canIssueCredits: [admin, tenant_manager, franchisee_owner, office_manager, employee].includes(user_role),
                canViewPartners: [admin, tenant_manager, franchisee_owner, partner].includes(user_role),
                isAdminOrTenant: user_role === admin || user_role === tenant_manager,
                isAdminOrTenantOrManager: user_role === admin || user_role === tenant_manager || user_role === office_manager,
                isAdminOrTenantOrOwnerOrManager: user_role === admin || user_role === tenant_manager || user_role === franchisee_owner || user_role === office_manager,
                isAdminOrTenantOrOwner: user_role === admin || user_role === tenant_manager || user_role === franchisee_owner,
                isTenantManager: user_role === tenant_manager,
                isFranchiseeOwner: user_role === franchisee_owner,
                isOfficeManager: user_role === office_manager,
                isPartnerOrPartnerManager: user_role === partner || user_role === partner_manager,
                isPartnerManager: user_role === partner_manager
              };
              canViewEmployees = [admin, tenant_manager, franchisee_owner, office_manager].includes(user_role); // Note: original condition for offices used `|| office_manager` (always truthy) — preserved intentionally

              canViewOffices = user_role === admin || user_role === tenant_manager || user_role === franchisee_owner || office_manager; // Fetch employees and offices in parallel

              _context3.next = 8;
              return Promise.all([canViewEmployees ? getAllEmployees() : Promise.resolve([null, null]), canViewOffices ? getAllOffices() : Promise.resolve([null, null])]);

            case 8:
              _yield$Promise$all3 = _context3.sent;
              _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 2);
              _yield$Promise$all4$ = _slicedToArray(_yield$Promise$all4[0], 2);
              employees = _yield$Promise$all4$[0];
              employeesErr = _yield$Promise$all4$[1];
              _yield$Promise$all4$2 = _slicedToArray(_yield$Promise$all4[1], 2);
              offices = _yield$Promise$all4$2[0];
              officesErr = _yield$Promise$all4$2[1];

              if (!employeesErr) {
                _context3.next = 18;
                break;
              }

              return _context3.abrupt("return", showApiError(employeesErr));

            case 18:
              if (!officesErr) {
                _context3.next = 20;
                break;
              }

              return _context3.abrupt("return", showApiError(officesErr));

            case 20:
              if (employees) {
                data.employees = employees;
                data.canViewEmployees = true;
              }

              if (offices) {
                data.offices = offices;
                data.canViewOffices = true;
              }

              return _context3.abrupt("return", data);

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function getRoleAdditionalData(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  var login = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(credentials) {
      var res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return loginService(credentials);

            case 2:
              res = _context4.sent;

              if (!(res !== null && res !== void 0 && res.two_factor_required)) {
                _context4.next = 5;
                break;
              }

              return _context4.abrupt("return", res);

            case 5:
              if (res !== null && res !== void 0 && res.access_token) window.location = '/dashboard';

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function login(_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var verify2fa = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(body) {
      var res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return verify2faService(body);

            case 2:
              res = _context5.sent;
              if (res !== null && res !== void 0 && res.access_token) window.location = '/dashboard';

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function verify2fa(_x4) {
      return _ref6.apply(this, arguments);
    };
  }();

  var logout = function logout() {
    return softLogout();
  };

  return ___EmotionJSX(UserContext.Provider, {
    value: _objectSpread(_objectSpread({}, state), {}, {
      setState: setState,
      changeCurrentOffice: changeCurrentOffice,
      login: login,
      verify2fa: verify2fa,
      logout: logout
    })
  }, state.loaded && children);
};
UserProvider.propTypes = {
  children: PropTypes.node,
  renderRedirect: PropTypes.func,
  renderLogout: PropTypes.func
};